// MUTATIONS
export const SET_IS_LOADING = 'setIsLoading';
export const SET_ALERT_DATA = 'setAlertData';

// ACTIONS
export const ACTION_SET_IS_LOADING = 'setIsLoading';

// GETTERS
export const GET_IS_LOADING = 'isLoading';